import React, { useEffect } from 'react'
import {
  Route,
  Switch,
  BrowserRouter as Router,
  Redirect,
  useRouteMatch,
  useLocation,
} from 'react-router-dom'

import Login from './Components/Login/Index'
import Register from './Components/Register/Index'
import { ThemeProvider } from 'styled-components'
import { darkTheme, lightTheme, GlobalStyle } from './globalAssets/theme'
import { AnimatePresence, AnimateSharedLayout, motion } from 'framer-motion'
import { Counter } from './features/counter/Counter'
import AccomodationDetails from './Components/Accomodation/Details'
import './App.css'
import Onboard from './Components/Onboard/Index'
import Error from './Components/404'
import 'antd/dist/antd.css'
import { useAppSelector } from './app/hooks'
import { mode } from './globalComponents/slice/modeSlice'
import Destination from './Components/Destination/Index'
import AppLayout from './globalComponents/AppLayout'
function App() {
  const uselocation = useLocation()
  console.log('location', uselocation)
  const lightmode = useAppSelector(mode)
  console.log('the current mode is', mode)

  useEffect(() => {})

  const getLocation = (pathname: any) => {
    let pathArr = pathname.split('/')
    console.log('the path name', pathArr[1])
    return pathArr.length > 2 ? pathArr[2] : pathArr[1]
  }
  return (
    <ThemeProvider theme={lightmode === 'dark' ? darkTheme : lightTheme}>
      <GlobalStyle />
      {/* <Router> */}
      <AnimatePresence exitBeforeEnter>
        <Switch location={uselocation} key={uselocation.pathname}>
          <Route path="/home">
            <AppLayout title={getLocation(uselocation.pathname)} />
          </Route>
          <Route exact path="/destination" component={Destination} />
          <Route exact path="/sign-up" component={Register} />
          <Route exact path="/onboard" component={Onboard} />
          <Route exact path="/login" component={Login} />
          <Redirect from="/" exact to="/login" />
          {/* <Route path="*" component={Error} /> */}
        </Switch>
      </AnimatePresence>
      {/* </Router> */}
    </ThemeProvider>
  )
}
export default App

// export const DashboardRoute = () => {

// };
